<template>
    <div class="ResidenceList">
        <h2>House List <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh" /></h2>
        <div class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Program:</label>
                        <select class="form-control" v-model="Filters.SubProgramID">
                            <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4"></div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
        </div>
        <vuetable :fields="ResidenceTableOptions.Fields"
                  pagination-path=""
                  :api-mode="false"
                  class="vue-datatable"
                  :data-manager="DataManager"
                  ref="datatable"
                  id="residencedatatableid">

            <template slot="ResidenceName" scope="props">
                <div class="ResidenceName">
                    <span class="underline pointer" @click="OpenRecord(props.rowData.Id, props.rowData)">{{ props.rowData.Name }}</span>
                </div>
            </template>
        </vuetable>
    </div>
</template>

<script>
    //import services
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../services/event-bus.js';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);

    export default {
        created() {
            this.$store.commit("Residences.ResidenceProfiles.Clear");
            this.$store.commit("Residences.ResidenceList.Clear");
            let vm = this;
            EventBus.$on('update-residence-list', function() {
                vm.GetResidences();
            });
        },
        beforeDestroy() {
            EventBus.$off('update-residence-list');
        },
        props: [],
        data: function () {
            return {
                search: "",
                Filters: {
                    SubProgramID: "",
                },
                ResidenceTableOptions: {
                    Fields: [
                        {
                            name: '__slot:ResidenceName',
                            title: 'Name',
                            sortField: 'Name'
                        },
                        {
                            name: 'Name',
                            title: 'Name',
                            visible: false
                        },
                        {
                            name: 'CurrentOccupancyCapacityString',
                            title: 'Occupancy',
                            sortField: 'CurrentOccupancy'
                        },
                        {
                            name: 'Address.City',
                            title: 'Location',
                            sortField: 'Address.City',
                        }
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetResidences();
                
            },
            GetResidences() {
                var vm = this;
                let openRecords = [];
                Object.keys(this.$store.state.Residences.ResidenceProfiles).map(function (key, index) {
                    openRecords.push(vm.$store.state.Residences.ResidenceProfiles[key].Id)
                });
                this.$MasterAPI.ExecuteRequest("GET", "Residential/Residences/GetResidences", { ...this.Filters, ExistingRecords: openRecords }, this.GetResidencesSuccess, () => { }, true);
            },
            GetResidencesSuccess(response) {
                this.$store.commit("Residences.ResidenceList.Replace", response.data.data);
                this.$refs.datatable.refresh();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenRecord(residenceID, residenceData) {
                this.$store.commit("Residences.ResidenceProfiles.Append", residenceData);

                this.$parent.ChangePaneShown(residenceID);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.$store.state.Residences.ResidenceList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                        
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                return visibleData;                  
            }
        },
        components: {
            Vuetable
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            var vm = this;
            //Get Child Records*/
            this.GetResidences();
            let getresidencesFunc = function () {
                vm.GetResidences();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getresidencesFunc);
        }
    }
</script>

<style scoped>
</style>